import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { format } from "date-fns";
import axios from "axios";

import Typography from "../../../../components/Typography";

import { ReactComponent as IconStartedRate } from "../../../../build/images/nps-dashboard-icons/started-rate-agent-icon.svg";
import { ReactComponent as IconCompletedRate } from "../../../../build/images/nps-dashboard-icons/completed-rate-agent-icon.svg";
import { ReactComponent as IconMoodRed } from "../../../../build/images/nps-dashboard-icons/red-mood-icon-agent.svg";
import { ReactComponent as IconMoodOrange } from "../../../../build/images/nps-dashboard-icons/orange-mood-agent-icon.svg";
import { ReactComponent as IconMoodYellow } from "../../../../build/images/nps-dashboard-icons/yellow-mood-agent-icon.svg";
import { ReactComponent as IconMoodLightGreen } from "../../../../build/images/nps-dashboard-icons/lightgreen-mood-agent-icon.svg";
import { ReactComponent as IconMoodGreen } from "../../../../build/images/nps-dashboard-icons/green-mood-agent-icon.svg";

import "./nps-date-three.css";
import Paperplane from "../../../Loading/Paperplane";
import { ResponsiveRadialBar } from "@nivo/radial-bar";
import { getMoodMapCall } from "../../../../actions";

export default function NpsDateThree({
  surveyInfosFromDateOne,
  loadingFromDateOne,
}) {
  const agentDashboardFilter = useSelector(
    (state) => state.agentDashboardFilter
  );
  const cardsOfCallCenterDash = useSelector(
    (state) => state.cardsOfCallCenterDash
  );

  const [loadingMoodMap, setLoadingMoodMap] = useState(false);

  const compilationRates = [
    {
      icon: <IconStartedRate />,
      value: surveyInfosFromDateOne.evalueted,
      title: "Iniciadas",
    },
    {
      icon: <IconCompletedRate />,
      value: surveyInfosFromDateOne.finished,
      title: "Completadas",
    },
  ];
  const graphComp = [
    {
      id: "Compilation",
      data: [
        {
          x: "Taxa de Compilação",
          y:
            Number(surveyInfosFromDateOne.evalueted) === 0
              ? 0
              : (
                  (Number(surveyInfosFromDateOne.finished) * 100) /
                  Number(surveyInfosFromDateOne.evalueted)
                ).toFixed(),
          color: "#008908",
          colorTrack: "rgba(0, 137, 8, 0.20)",
        },
      ],
    },
  ];
  const [percentage, setPercentage] = useState(0);
  const [iconsMood, setIconsMood] = useState([
    {
      icon: <IconMoodRed />,
      percentValue: "0%",
    },
    {
      icon: <IconMoodOrange />,
      percentValue: "0%",
    },
    {
      icon: <IconMoodYellow />,
      percentValue: "0%",
    },
    {
      icon: <IconMoodLightGreen />,
      percentValue: "0%",
    },
    {
      icon: <IconMoodGreen />,
      percentValue: "0%",
    },
  ]);

  const progressBarStyle = {
    display: "flex",
    width: "100%",
    height: "16px",
    padding: "8px 10px",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    borderRadius: "32px",
    background:
      "linear-gradient(90deg, #C90000 0%, #FFB700 50.45%, #008908 100%)",
    position: "relative",
  };
  const ballStyle = {
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    background: "#008908",
    border: "5px solid #fff",
    position: "relative",
    left: `${percentage - 50}%`,
  };

  const CenteredMetric = ({ center, bars }) => {
    const ref = useRef(null);
    if (bars.length) {
      return (
        <text
          x={center[0]}
          y={center[1]}
          style={{
            fontSize: 32,
            fontFamily: "Inter",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "28px",
            fill: `${bars[0].color}`,
          }}
          textAnchor="middle"
          dominantBaseline="central"
          ref={ref}
        >
          {`${bars[0].value}%`}
        </text>
      );
    }

    return null;
  };

  async function getMoodMapV2(source) {
    let updatedPercentage = 0;
    let updatedIconsMood = [
      {
        icon: <IconMoodRed />,
        percentValue: "0%",
      },
      {
        icon: <IconMoodOrange />,
        percentValue: "0%",
      },
      {
        icon: <IconMoodYellow />,
        percentValue: "0%",
      },
      {
        icon: <IconMoodLightGreen />,
        percentValue: "0%",
      },
      {
        icon: <IconMoodGreen />,
        percentValue: "0%",
      },
    ];
    setLoadingMoodMap(true);
    const response = await getMoodMapCall(
      format(
        new Date(agentDashboardFilter.initialDateAgenteScreen),
        "yyyy-MM-dd"
      ),
      format(new Date(agentDashboardFilter.finalDateAgentScreen), "yyyy-MM-dd"),
      agentDashboardFilter.channelSelectedAgentScreen
        .map((option) => option.id)
        .join(),
      agentDashboardFilter.avaliationSelectedAgentScreen
        .map((option) => option.id)
        .join(),
      source
    );

    const hasResponse = !!response && response.status === 200;
    if (hasResponse) {
      const data = response.data;
      const hasData = !!data && data.length > 0;
      if (hasData) {
        let numerator = 0;
        let denominator = 0;
        let numeratorRed = 0;
        let numeratorOrange = 0;
        let numeratorYellow = 0;
        let numeratorLightGreen = 0;
        let numeratorGreen = 0;

        data.forEach((datum) => {
          const count = Number(datum.count) ? Number(datum.count) : 0;
          const value = Number(datum.valor) ? Number(datum.valor) : 0;

          numerator = numerator + count * value;
          denominator = denominator + count;

          const isRed = value === 0 || value === 1;
          if (isRed) {
            numeratorRed = numeratorRed + count;
          }
          const isOrange = value === 2;
          if (isOrange) {
            numeratorOrange = numeratorOrange + count;
          }
          const isYellow = value === 3;
          if (isYellow) {
            numeratorYellow = numeratorYellow + count;
          }
          const isLightGreen = value === 4;
          if (isLightGreen) {
            numeratorLightGreen = numeratorLightGreen + count;
          }
          const isGreen = value === 5;
          if (isGreen) {
            numeratorGreen = numeratorGreen + count;
          }

          const percentageRed = denominator
            ? ((numeratorRed / denominator) * 100).toFixed(2)
            : 0;
          const percentageOrange = denominator
            ? ((numeratorOrange / denominator) * 100).toFixed(2)
            : 0;
          const percentageYellow = denominator
            ? ((numeratorYellow / denominator) * 100).toFixed(2)
            : 0;
          const percentageLightGreen = denominator
            ? ((numeratorLightGreen / denominator) * 100).toFixed(2)
            : 0;
          const percentageGreen = denominator
            ? ((numeratorGreen / denominator) * 100).toFixed(2)
            : 0;

          updatedIconsMood = [
            {
              icon: <IconMoodRed />,
              percentValue: `${percentageRed}%`,
            },
            {
              icon: <IconMoodOrange />,
              percentValue: `${percentageOrange}%`,
            },
            {
              icon: <IconMoodYellow />,
              percentValue: `${percentageYellow}%`,
            },
            {
              icon: <IconMoodLightGreen />,
              percentValue: `${percentageLightGreen}%`,
            },
            {
              icon: <IconMoodGreen />,
              percentValue: `${percentageGreen}%`,
            },
          ];
        });

        const finalGrade = denominator ? numerator / denominator : 0;
        updatedPercentage = (finalGrade / 5) * 100;
      }
      setIconsMood(updatedIconsMood);
      setPercentage(updatedPercentage);
      setLoadingMoodMap(false);
    } else {
      setIconsMood(updatedIconsMood);
      setPercentage(updatedPercentage);
      const hasError = !!response && !!response.error;
      if (hasError) {
        const isCanceled = axios.isCancel(response.error);
        if (!isCanceled) {
          setLoadingMoodMap(false);
        }
      }
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde."
      );
    }
  }

  useEffect(() => {
    const sourceMoodMap = axios.CancelToken.source();

    const hasAgentDashboardFilter = !!agentDashboardFilter;
    if (hasAgentDashboardFilter) {
      getMoodMapV2(sourceMoodMap);
    }

    return () => {
      sourceMoodMap.cancel("Cancelado pelo usuário (sourceMoodMap)");
    };
  }, [agentDashboardFilter]);

  return (
    <section className="nps-date-three">
      {cardsOfCallCenterDash.card7 && (
        <div className="nps-zone-call-center">
          <div className="nps-zone-content nps-zone-content-agent">
            {loadingFromDateOne ? (
              <Paperplane className="nps-zone-content__loading" />
            ) : (
              <div className="nps-zone-content__compilation-rate-agent">
                <div className="nps-zone-content__compilation-rate-agent__infos">
                  <h4 className="nps-zone-content__compilation-rate-agent__infos__title">
                    Taxa de compilação
                  </h4>
                  <div className="nps-zone-content__compilation-rate-agent__infos__info-items">
                    {compilationRates.map((compilationRate, index) => {
                      return (
                        <div
                          key={index}
                          className="nps-zone-content__compilation-rate-agent__infos__info-items__item"
                        >
                          <div className="nps-zone-content__compilation-rate-agent__infos__info-items__item__icon">
                            {compilationRate.icon}
                          </div>
                          <div className="nps-zone-content__compilation-rate-agent__infos__info-items__item__rate-info">
                            <h3 className="nps-zone-content__compilation-rate-agent__infos__info-items__item__rate-info__value">
                              {compilationRate.value}
                            </h3>
                            <span className="nps-zone-content__compilation-rate-agent__infos__info-items__item__rate-info__title">
                              {compilationRate.title}
                            </span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div>
                  <div className="compilation-rate-graphic__isGraphic">
                    <ResponsiveRadialBar
                      data={graphComp}
                      maxValue={100}
                      startAngle={0}
                      endAngle={360}
                      colors={{ datum: "data.color" }}
                      tracksColor={"rgba(0, 137, 8, 0.20)"}
                      borderWidth={0}
                      borderColor={{
                        from: "color",
                        modifiers: [["darker", "0"]],
                      }}
                      innerRadius={0.8}
                      cornerRadius={2}
                      margin={{ top: 0, bottom: 0 }}
                      enableRadialGrid={false}
                      enableCircularGrid={false}
                      radialAxisStart={null}
                      circularAxisOuter={null}
                      tooltip={({ bar }) => {
                        return (
                          <div className="tooltip-text-radial">
                            <Typography.H6 color={"white"}>
                              {`Completadas - ${bar.value}%`}
                            </Typography.H6>
                          </div>
                        );
                      }}
                      layers={["tracks", "bars", CenteredMetric]}
                      legends={[]}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {cardsOfCallCenterDash.card8 && (
        <div className="profile-mapping-agent">
          <header className="profile-mapping__header">
            <h4>Mapa de humor</h4>
          </header>

          <div className="profile-mapping-agent__mood-container">
            {loadingMoodMap ? (
              <Paperplane />
            ) : (
              <div className="profile-mapping-agent__mood-container__holder">
                <div className="profile-mapping-agent__mood-container__holder__icons">
                  {iconsMood.map((iconMood, index) => {
                    return (
                      <div
                        key={index}
                        className="profile-mapping-agent__mood-container__holder__icons__item"
                      >
                        <div className="profile-mapping-agent__mood-container__holder__icons__item__icon">
                          {iconMood.icon}
                        </div>
                        <span className="profile-mapping-agent__mood-container__holder__icons__item__percent">
                          {iconMood.percentValue}
                        </span>
                      </div>
                    );
                  })}
                </div>
                <div style={progressBarStyle}>
                  <div style={ballStyle}></div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </section>
  );
}
